<template>
  <div class="dialog-wrap">
    <el-dialog
      title="广告编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="广告标题"
          prop="title"
        >
          <el-input
            v-model="dataForm.title"
            placeholder="请输入广告标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="广告封面"
          prop="picture_url"
        >
          <el-upload
            class="cover-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload"
          >
            <img
              v-if="dataForm.picture_url"
              :src="dataForm.picture_url"
              class="cover"
            >
            <i
              v-else
              class="el-icon-plus cover-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="广告位置"
          prop="position_code"
        >
          <el-select
            v-model="dataForm.position_code"
            placeholder="请选择广告位置"
            style="width: 100%;"
          >
            <el-option
              v-for="item in positions"
              :key="item.id"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="关联用户分组"
          prop="user_category_ids"
        >
          <el-select
            multiple
            v-model="dataForm.user_category_ids"
            placeholder="请选择关联用户分组"
            style="width: 100%;"
          >
            <el-option
              v-for="(item,index) in $store.state.userCategorys"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="客户端"
          prop="client_ids"
        >
          <el-select
            v-model="dataForm.client_ids"
            multiple
            placeholder="请选择客户端"
            style="width: 100%;"
          >
            <el-option
              v-for="item in clients"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="排序值"
          prop="sort"
        >
          <el-input
            v-model="dataForm.sort"
            placeholder="请输入排序值，纯数字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="有效期"
          prop="time"
        >
          <el-date-picker
            v-model="dataForm.time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="绑定类型"
          prop="content_type"
        >
          <el-select
            v-model="dataForm.content_type"
            placeholder="请选择绑定类型"
            style="width: 100%;"
          >
            <el-option
              label="广告链接"
              :value="1"
            >
            </el-option>
            <el-option
              label="关联内容"
              :value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="广告链接"
          prop="link_url"
          v-if="dataForm.content_type==1"
        >
          <el-input
            v-model="dataForm.link_url"
            placeholder="请输入广告链接"
          ></el-input>
        </el-form-item>
        <div
          class="ref-box"
          v-if="dataForm.content_type==2"
        >
          <el-form-item label="关联类型">
            <el-select
              v-model="dataForm.ref_type"
              placeholder="请选择关联类型"
              style="width: 100%;"
              @change="handleTypeChange"
            >
              <el-option
                v-for="item in types"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联内容">
            <el-input
              v-if="dataForm.ref_type != 6"
              v-model="dataForm.ref_content.name"
              :disabled="dataForm.ref_type == 0"
              placeholder="请选择关联内容"
              @focus="handleContentChoose"
            ></el-input>
            <el-select
              v-else
              v-model="dataForm.link_url"
              placeholder="请选择QQ群号"
              style="width: 100%;"
            >
              <el-option
                v-for="item in groups"
                :key="item.value"
                :label="item.label"
                :value="item.number"
              >
                {{item.name}}/{{item.number}}
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item
          label="在线状态"
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
    <ContentChoose
      :visible="contentChooseDialog"
      @close="contentChooseDialog = false"
      @submit="handleContentChooseSave"
      :ref_type="dataForm.ref_type"
    ></ContentChoose>
  </div>
</template>

<script>
import ContentChoose from "@/components/dialog/ContentChoose";
import { adUpdate, adPositionList, clientList, qqGroupList } from '@/api/operation'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

export default {
  components: {
    ContentChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      contentChooseDialog: false,
      dataForm: this.content || {
        picture_url: '',
        ref_type: 0,
        ref_content: {}
      },
      types: [
        { label: '无关联', value: 0 },
        { label: '课程', value: 1 },
        { label: '题库', value: 2 },
        { label: '阅读资料', value: 3 },
        { label: '实体资料', value: 4 },
        { label: '信息资讯', value: 5 },
        { label: 'QQ群', value: 6 },

      ],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      positions: [],
      clients: [],
      groups: [],
      rules: {
        title: [{ required: true, message: '请输入广告标题', trigger: 'blur' }],
        link_url: [{ required: true, message: '请输入广告链接', trigger: 'blur' }],
        picture_url: [{ required: true, message: '请上传广告封面', trigger: 'blur' }],
        position_code: [{ required: true, message: '请选择广告位置', trigger: 'change' }],
        client_ids: [{ required: true, message: '请选择客户端', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }],
        content_type: [{ required: true, message: '请选择绑定类型', trigger: 'change' }],
        time: [
          {
            required: true,
            message: "请选择有效期",
            trigger: "blur",
          },
        ],
      },
      timeOptionRange: '',
      pickerOptions: {
        onPick: time => {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: time => {
          let timeOptionRange = this.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 30 * 1000;
          if (timeOptionRange) {
            return (time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() <
              timeOptionRange.getTime() - secondNum);
          }
        }
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchPositionList()
        this.fetchClientList()
        this.fetchQQGroupList()
      }
    },
    content(val) {
      this.dataForm = val
      this.dataForm.ref_content = this.dataForm.ref_content || {}
      this.$set(this.dataForm, "time", [
        this.dataForm.start_time,
        this.dataForm.end_time,
      ]);
      if (val.client_ids) {
        this.dataForm.client_ids = val.client_ids.split(',').map(v => Number(v))
      }
      if (val.user_category_ids) {
        this.dataForm.user_category_ids = val.user_category_ids.split(',').map(v => Number(v))
      }
    }
  },
  methods: {
    fetchQQGroupList() {
      qqGroupList({ isPaging: 0 }).then(res => {
        this.groups = res.list
      })
    },
    fetchPositionList() {
      adPositionList({ isPaging: 0 }).then(res => {
        this.positions = res.list
      })
    },
    fetchClientList() {
      clientList({ isPaging: 0 }).then(res => {
        this.clients = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            title: this.dataForm.title,
            link_url: this.dataForm.link_url,
            picture_url: this.dataForm.picture_url,
            position_code: this.dataForm.position_code,
            client_ids: this.dataForm.client_ids ? this.dataForm.client_ids.join(',') : '',
            sort: this.dataForm.sort,
            status: this.dataForm.status ? 1 : 0,
            ref_type: this.dataForm.ref_type,
            ref_id: this.dataForm.ref_id,
            start_time: this.dataForm.time[0],
            end_time: this.dataForm.time[1] + 86399000,
            user_category_ids: this.dataForm.user_category_ids ? this.dataForm.user_category_ids.join(',') : "",
            content_type: this.dataForm.content_type,
          }
          adUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleTypeChange(value) {
      this.dataForm.ref_id = null
      this.dataForm.ref_content = {}
    },
    handleContentChoose() {
      this.contentChooseDialog = true
    },
    handleContentChooseSave(value) {
      this.dataForm.ref_id = value.id
      this.dataForm.ref_content = value
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;

    .cover-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 100%;
    }
    .cover-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .cover-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      max-width: 100%;
      max-height: 200px;
      line-height: 100px;
      text-align: center;
    }
    .cover {
      display: block;
      max-width: 100%;
      max-height: 200px;
      object-fit: cover;
      margin: 0 auto;
    }
    .ref-box {
      /deep/ .el-input__inner {
        border-style: dashed;
      }
    }
  }
}
</style>
